var globals =  
    [
        {
            paginacion: {
                rango: [5,10,25],
            },
        }
    ];
            

export default globals;

